import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [props: string]: any
}

export const MeetingWappIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '24px', height: '24px', ...sx }}
    {...props}
  >
    <path
      d="M21 14h-1V4h1a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22c.2 0 .39-.06.55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28c.16.11.35.17.55.17a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2Zm-3 0H6V4h12v10Z"
      fill="url(#MeetingWappIcon)"
    />
    <defs>
      <linearGradient
        id="MeetingWappIcon"
        x1="12"
        y1="2"
        x2="12"
        y2="22.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B09B" />
        <stop offset="1" stopColor="#96C93D" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

MeetingWappIcon.defaultProps = {
  sx: null,
}
